const optionsObjectToArray = object => {
    let options = [];
    for (const [value, label] of Object.entries(object)) {
        options.push({
            value,
            label,
        });
    }
    return options;
};

const normalizeArrayObjects = (
    array,
    valueName,
    labelName,
    valueFn,
    labelFn
) => {
    return array.map(item => {
        const value = valueFn
            ? valueFn(item[valueName], item[labelName])
            : item[valueName];
        const label = labelFn
            ? labelFn(item[valueName], item[labelName])
            : item[labelName];

        return {
            value,
            label,
        };
    });
};

export {optionsObjectToArray, normalizeArrayObjects};
